/* eslint-disable */
export default {
  forward: 'Encaminhar',
  reply: 'Responder',
  ignore: 'Ignorar',
  toVoicemail: 'Para caixa postal',
  answer: 'Atender',
  answerAndEnd: 'Atender e terminar',
  answerAndHold: 'Atender e colocar em espera',
} as const;

// @key: @#@"forward"@#@ @source: @#@"Forward"@#@
// @key: @#@"reply"@#@ @source: @#@"Reply"@#@
// @key: @#@"ignore"@#@ @source: @#@"Ignore"@#@
// @key: @#@"toVoicemail"@#@ @source: @#@"To Voicemail"@#@
// @key: @#@"answer"@#@ @source: @#@"Answer"@#@
// @key: @#@"answerAndEnd"@#@ @source: @#@"Answer & End"@#@
// @key: @#@"answerAndHold"@#@ @source: @#@"Answer & Hold"@#@
